<template>
  <div>
    <CRow>
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                     is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol v-if="$hasAuthor('ROLE_ADMIN')" xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect :options="orgSelect.options" :data="orgSelect.data"
                    ref="orgSelect"></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/schedule-management/schedule-add.html')"
            >
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <!-- <template #type="{ item }">
            <td>
              <span v-if="item.type == 0" class="badge badge-secondary">Văn bản</span>
              <span v-else class="badge badge-info">Media</span>
            </td>
          </template> -->
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #fromDate="{ item }">
            <td v-if="item.fromDate != null">
              {{ $helper.formatDateDDMMYYYY(item.fromDate) }}
            </td>
            <td v-if="item.fromDate == null"></td>
          </template>
          <template #titleSlide="{ item }">
            <td style="font-weight: bold; cursor: pointer" @click="viewSlideShow(item.slideShowId)">{{
                item.titleSlide
              }}
            </td>
          </template>
          <template #toDate="{ item }">
            <td v-if="item.toDate != null">
              {{ $helper.formatDateDDMMYYYY(item.toDate) }}
            </td>
            <td v-if="item.toDate == null"></td>
          </template>
          <template #devices="{ item }">
            <td v-if="item.devices != null">
              <span v-for="i of $helper.convertStringToArray(item.devices, ',')"
                    class="badge badge-secondary mr-2">{{ i }}</span>
            </td>
            <td v-if="item.devices == null"></td>
          </template>
          <template #active="{item}">
            <td>
                <span v-if="item.active == 1" class="dot-custom dot-success">
                Hoạt động
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Hủy'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.fromDate, item.toDate)"/>
              </span>
              <span v-else class="dot-custom dot-danger">
                Đã hủy
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Kích hoạt'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.fromDate, item.toDate)"/>
              </span>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Xem chi tiết'"
                  square
                  size="sm"
                  @click="$router.push(`${item.id}/managed-shedule-detail.html`)"
                >
                  <i class="fa fa-eye"></i>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          với các thiết bị:
          <span v-for="i of exist.devices">
            <br/>
            {{ '- ' + i }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="$router.push(`${exist.id}/managed-shedule-detail.html`)">
          <i class="fa fa-eye"></i> Xem lịch
          đã tồn tại
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import {USER_NAME} from '../../constant';
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "ScheduleList",
  components: {
    BaseSelect,
    BaseFormLoading,
    BaseTable,
    DatePicker,
    ModalConfirm,
    BaseSwitch
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("update_active", {
      url: "/schedule/update-active",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.active == true ? "hủy toàn bộ lịch" : "kích hoạt toàn bộ lịch", 'từ ngày'
          , that.$helper.formatDateDDMMYYYY(that.actionData.model.fromDate) + ' đến ngày '
          + that.$helper.formatDateDDMMYYYY(that.actionData.model.toDate))
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
          userName: localStorage.getItem(USER_NAME),
          active: that.actionData.model.active == true ? 0 : 1
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({message: that.actionData.model.active == true ? "Hủy lịch thành công" : "Kích hoạt lịch thành công"});
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });

    return {
      loading: {value: false},
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          active: null,
          fromDate: null,
          toDate: null
        }
      },
      dateRange: {
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      orgSelect: {
        options: {
          label: "Đơn vị",
          selectAllText: "Tất cả đơn vị",
          filter: true,
          keyField: "value",
          valueField: "text",
          lazyLoad: that.$hasAuthor("ROLE_ADMIN") ? false : true
        },
        data: {
          model: "",
          name: "orgId",
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Thời gian tạo"},
            {key: "titleSlide", label: "Trình diễn"},
            {key: "fromDate", label: "Phát từ ngày"},
            {key: "toDate", label: "Đến ngày"},
            {key: "devices", label: "Thiết bị phát"},
            // {key: "active", label: "Trạng thái", _style: "width:10%"},
            {key: "action", label: "Thao tác", sorter: false, filter: false}
          ],
          slots: [
            "index",
            "createDate",
            "titleSlide",
            "fromDate",
            "toDate",
            "devices",
            // "active",
            "action"
          ],
          sorter: true,
          columnFilter: false,
          tableFilter: false,
        },
        dataSource: {
          url: "/schedule/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            params.orgId = that.orgSelect.data.model
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, id, active, fromDate, toDate) {
      let actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.active = active || null;
      actionData.fromDate = fromDate || null;
      actionData.toDate = toDate || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    viewSlideShow(slideShowId) {
      this.$router.push(`/files-screen-management/${slideShowId}/slide-show-update.html`)
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
